import ClientService from '@/services/requests/clientService'
import Store from '@/store/computed/storeHelpers'
export default {
  methods: {
    getClients() {
      this.loadingClients = true
      return ClientService.getAllClients()
        .then(result => {
          this.loadingClients = false
          this.clients = result.data.result
          return result.data.result
        })
        .catch(err => {
          this.loadingClients = false
          console.log(err)
          this.snackError()
        })
    }
  },
  computed: {
    loadingClients: Store.getSet({ store: 'clients', prop: 'loadingClients' }),
    clients: Store.getSet({ store: 'clients', prop: 'clients' })
  },
  mounted() {
    if (!this.clients.length && this.$route.name !== 'audit') {
      this.getClients()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.clients = []
  }
}
